import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.odin = bracketIndenting()
